import { useEffect, useState } from 'react';
import {
  ExaminingTeamMembers,
  CardLimits,
} from '../SessionsParametersDialogContent/SessionsParametersDialogContent.types';
import { Modal } from '../../../../components/Modal/Modal.component';
import { Examiner, ITaskGroup } from '../../../../models/taskGroup.types';
import { getCardLimitsByExaminingTeamId } from '../../../../services/exams/examiningTeam/examiningTeam.service';
import { SessionsParametersCardLimitPerExaminer } from './SessionsParametersCardLimitPerExaminer.component';

interface SessionsParametersCardLimitPerExaminerDialogProps {
  selectedExaminer: Examiner;
  selectedTaskGroup: ITaskGroup;
  examiningTeamId: string;
  onClose: () => void;
  onOpen: boolean;
}

export const SessionsParametersCardLimitPerExaminerDialog: React.FC<
  SessionsParametersCardLimitPerExaminerDialogProps
> = ({ selectedExaminer, selectedTaskGroup, examiningTeamId, onClose, onOpen }) => {
  const [cardLimits, setCardLimits] = useState<ExaminingTeamMembers[]>([]);
  const [apiResponse, setApiResponse] = useState<ExaminingTeamMembers[]>([]);
  const [defaultCardLimit, setDefaultCardLimit] = useState<CardLimits>();
  const [reload, setRoload] = useState<boolean>(false);

  useEffect(() => {
    if (examiningTeamId || reload) {
      getCardLimitsByExaminingTeamId(examiningTeamId)
        .then((response) => {
          setCardLimits(response.examiningTeamMembers);
          const examiningTeamMembersCopy = JSON.parse(JSON.stringify(response.examiningTeamMembers));
          setApiResponse(examiningTeamMembersCopy);
          setDefaultCardLimit(response.defaultCardLimit);
        })
        .catch(() => {
          setCardLimits([]);
        });
    }
  }, [examiningTeamId, reload]);

  const handleReload = () => {
    setRoload(true);
  };

  return (
    <Modal
      xCloseButton={onClose}
      id={'limitCardPerExaminer'}
      open={onOpen}
      size="md"
      title={`Indywidualne limity kart egzaminatorów w zespole: ${selectedTaskGroup?.name}- (PZE) ${selectedExaminer?.firstName} ${selectedExaminer?.lastName}`}
    >
      {cardLimits && defaultCardLimit && selectedTaskGroup && (
        <SessionsParametersCardLimitPerExaminer
          apiResponse={JSON.stringify(apiResponse)}
          items={cardLimits}
          onClose={onClose}
          reload={handleReload}
          defaultCardLimit={defaultCardLimit}
          selectedTaskGroupId={selectedTaskGroup.taskGroupId}
        />
      )}
    </Modal>
  );
};
